import { render, staticRenderFns } from "./DPH26.vue?vue&type=template&id=724a6171&scoped=true"
import script from "./DPH26.vue?vue&type=script&lang=js"
export * from "./DPH26.vue?vue&type=script&lang=js"
import style0 from "./DPH26.vue?vue&type=style&index=0&id=724a6171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a6171",
  null
  
)

export default component.exports